import * as React from 'react';
import { mouseEventProps } from './mouseEventProps';
import { joinClass } from './symbolUtils';
export const Stage = ({ children, inEditor, symbol, }) => {
    var _a, _b, _c;
    const { clickClass, mouseEventStyles, onClick } = mouseEventProps(symbol, inEditor);
    const className = joinClass('stage', clickClass);
    const maxContentWidth = (_c = (_b = (_a = window.ADAPT) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.globalAttributes) === null || _c === void 0 ? void 0 : _c.maxContentWidth;
    const sharedStyles = Object.assign({ width: '100%', height: '100%' }, mouseEventStyles);
    /**
     * If `maxContentWidth` is present, the Stage is centered in
     * the `div#root`. Otherwise, it covers the entire `div#root`.
     */
    const style = maxContentWidth
        ? Object.assign(Object.assign({}, sharedStyles), { position: 'relative', maxWidth: maxContentWidth, margin: '0 auto', overflow: 'hidden' }) : Object.assign(Object.assign({}, sharedStyles), { left: 0, position: 'absolute', top: 0 });
    return (React.createElement("div", { className: className, onClick: onClick, style: style }, children));
};
export default Stage;
